import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { ShowHide }   from "./concerns/showHide";

export default class extends Controller {

  static targets = [
    "confirmationMessage",
    "body",
    "visibilityHint",
    "gifSelection",
    "gifImage",
    "gifLink",
    "gifId",
    "gifUrl",
    "gifPageUrl",
    "gifAltText",
    "gifWidth",
    "gifHeight"
  ]

  static outlets = ["giphy-picker"]
  static values = { focusBody: Boolean }

  initialize() {
    Loggable(this, { debug: false })
    ShowHide(this)
  }

  connect() {
    this.log("connected")
    if (this.hasBodyTarget) {
      if (this.bodyTarget.value) this.resizeBody()
      if (this.focusBodyValue) this.bodyTarget.focus({ preventScroll: true })
    }
  }

  submit(event) {
    this.log("submit")
    this.element.requestSubmit() // this will trigger the form submission AND works with Turbo
    event.preventDefault()
  }

  hideConfirmationMessage(event){
    event.preventDefault()
    if (this.hasConfirmationMessageTarget) {
      this.hide(this.confirmationMessageTarget)
    }
  }

  preventDefault(event) {
    this.log("preventDefault")
    event.preventDefault()
  }

  toggleVisibilityHint(event){
    const el = event.target
    this.log("toggleVisibilityHint", el.value)
    this.hideAll(this.visibilityHintTargets)
    this.visibilityHintTargets.filter(hint => hint.dataset.visibility == el.value).forEach( hint => this.show(hint))
  }

  /* as content grows, adjust the height of the textarea */
  resizeBody(event){
    this.log("resizeBody")
    this.bodyTarget.style.height = "auto"
    this.bodyTarget.style.height = (this.bodyTarget.scrollHeight) + "px"
  }

  prepareGifPicker() {
    this.giphyPickerOutlet.activate(this)
  }

  selectGif(gif) {
    this.gifIdTarget.value = gif.id
    this.gifUrlTarget.value = gif.url
    this.gifPageUrlTarget.value = gif.page_url
    this.gifAltTextTarget.value = gif.alt_text
    this.gifWidthTarget.value = gif.width
    this.gifHeightTarget.value = gif.height

    this.gifImageTarget.src = gif.url
    this.gifImageTarget.alt = gif.alt_text
    this.gifImageTarget.width = gif.width
    this.gifImageTarget.height = gif.height
    this.gifLinkTarget.href = gif.page_url
    this.show(this.gifSelectionTarget)
  }

  removeGif(event) {
    event?.preventDefault()
    this.gifIdTarget.value = ""
    this.gifUrlTarget.value = ""
    this.gifPageUrlTarget.value = ""
    this.gifAltTextTarget.value = ""
    this.gifWidthTarget.value = ""
    this.gifHeightTarget.value = ""
    this.hide(this.gifSelectionTarget)
  }

}
